var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.792,
    height: 63.182,
    viewBox: "0 0 69.792 63.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 30.591,
    height: 30.591
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-383.426-82.818h-4.4a1.219,1.219,0,0,1-1.218-1.218v-45.748a1.2,1.2,0,0,0-1.2-1.2h-52.719a1.2,1.2,0,0,0-1.2,1.2v45.748a1.219,1.219,0,0,1-1.218,1.218h-4.4A1.219,1.219,0,0,1-451-84.036v-57.853A3.115,3.115,0,0,1-447.889-145h62.57a3.115,3.115,0,0,1,3.111,3.111v57.853A1.22,1.22,0,0,1-383.426-82.818Zm-59.632-57.955a1.1,1.1,0,0,0-1.1,1.1v3.41a1.1,1.1,0,0,0,1.1,1.1h52.908a1.1,1.1,0,0,0,1.1-1.1v-3.41a1.1,1.1,0,0,0-1.1-1.1Zm49.74,15.386h-46.57a1.061,1.061,0,0,1-1.06-1.058v-1.714a1.061,1.061,0,0,1,1.06-1.058h46.57a1.061,1.061,0,0,1,1.06,1.058v1.714A1.061,1.061,0,0,1-393.318-125.387Zm2.2-10.805h-50.975a.758.758,0,0,1-.756-.758v-2.032a.757.757,0,0,1,.756-.756h50.975a.757.757,0,0,1,.756.756v2.032A.758.758,0,0,1-391.116-136.193Z",
    transform: "translate(451.5 145.5)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(19.601 32.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M15.3,0a15.3,15.3,0,1,0,15.3,15.3A15.3,15.3,0,0,0,15.3,0m0,27.2A11.9,11.9,0,1,1,27.2,15.3,11.9,11.9,0,0,1,15.3,27.2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M26.513,10.886A11.055,11.055,0,1,0,29.747,18.7a10.977,10.977,0,0,0-3.234-7.814M9.159,18.714V18.7a9.493,9.493,0,0,1,1.814-5.591,1.111,1.111,0,0,1,1.8,0l2.15,2.958a1.657,1.657,0,0,1-.828,2.55l-3.5,1.136a1.1,1.1,0,0,1-1.438-1.034m8.034,8a1.108,1.108,0,0,1-1.447,1.057A9.579,9.579,0,0,1,11,24.325a1.111,1.111,0,0,1,.547-1.717l3.479-1.13a1.657,1.657,0,0,1,2.169,1.576Zm.166-12.424-2.152-2.962a1.111,1.111,0,0,1,.562-1.709,9.554,9.554,0,0,1,5.862,0,1.111,1.111,0,0,1,.562,1.709L20.04,14.291a1.657,1.657,0,0,1-2.681,0M26.4,24.325a9.579,9.579,0,0,1-4.748,3.447,1.108,1.108,0,0,1-1.447-1.057V23.053a1.657,1.657,0,0,1,2.169-1.576l3.478,1.13a1.111,1.111,0,0,1,.548,1.717m.4-4.577-3.5-1.136a1.658,1.658,0,0,1-.829-2.55l2.15-2.958a1.111,1.111,0,0,1,1.8,0A9.493,9.493,0,0,1,28.24,18.7v.015A1.1,1.1,0,0,1,26.8,19.748",
    transform: "translate(-3.404 -3.404)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.b548ba9dc9cf0e8485e6acc07c9609d7.svg";
export { ForwardRef as ReactComponent };